/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The cloud provider of the credential.
 */
export const Provider = {
  AwsIam: "aws_iam",
  GcpIam: "gcp_iam",
} as const;
/**
 * The cloud provider of the credential.
 */
export type Provider = ClosedEnum<typeof Provider>;

/**
 * A GCP IAM external credential.
 */
export type GcpIamCredential = {
  /**
   * When the credential was created.
   */
  createdAt: Date;
  /**
   * The ID of the external credential.
   */
  id: string;
  /**
   * The service account Speakeasy impersonates (impersonation approach, or the WIF hop).
   */
  impersonateServiceAccount?: string | undefined;
  /**
   * A human-readable name for the credential.
   */
  name: string;
  /**
   * The organization that owns the credential.
   */
  organizationId: string;
  /**
   * The cloud provider of the credential.
   */
  provider: Provider;
  /**
   * When the credential was last updated.
   */
  updatedAt: Date;
  /**
   * Workload Identity Federation pool ID.
   */
  wifPoolId?: string | undefined;
  /**
   * GCP project number backing the WIF pool.
   */
  wifProjectNumber?: string | undefined;
  /**
   * Workload Identity Federation provider ID.
   */
  wifProviderId?: string | undefined;
};

/** @internal */
export const Provider$inboundSchema: z.ZodMiniEnum<typeof Provider> = z.enum(
  Provider,
);

/** @internal */
export const GcpIamCredential$inboundSchema: z.ZodMiniType<
  GcpIamCredential,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    impersonate_service_account: z.optional(z.string()),
    name: z.string(),
    organization_id: z.string(),
    provider: Provider$inboundSchema,
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    wif_pool_id: z.optional(z.string()),
    wif_project_number: z.optional(z.string()),
    wif_provider_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "impersonate_service_account": "impersonateServiceAccount",
      "organization_id": "organizationId",
      "updated_at": "updatedAt",
      "wif_pool_id": "wifPoolId",
      "wif_project_number": "wifProjectNumber",
      "wif_provider_id": "wifProviderId",
    });
  }),
);

export function gcpIamCredentialFromJSON(
  jsonString: string,
): SafeParseResult<GcpIamCredential, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GcpIamCredential$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GcpIamCredential' from JSON`,
  );
}
